import { useLazyQuery } from '@apollo/client'
import { battleDemoPvPSeasonSchema } from '@src/deserialize/yup/battleDemo'
import graphql from '@src/graphql/query/getBattleDemoPvPSeasons'
import { BattleDemoSeason } from '@src/types/battleDemo'
import * as R from 'ramda'
import { useCallback, useState } from 'react'

const useGetBattleDemoPvPSeasons = (): Hook => {
  const [fetchSeasons, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<BattleDemoSeason[]>([])

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const { isGuild } = request

      const response = await fetchSeasons({
        variables: {
          isGuild
        }
      })

      const seasons = R.map(
        item => battleDemoPvPSeasonSchema.cast(item) as BattleDemoSeason,
        response.data.getPvpSeasonSchedules as any[]
      )

      setData(seasons)

      return seasons
    },
    [fetchSeasons]
  )

  return {
    data,
    loading,
    fetch
  }
}

type Request = {
  isGuild: boolean
}

type Response = BattleDemoSeason[]

type Hook = {
  data: Response
  loading: boolean
  fetch: (request: Request) => Promise<Response>
}

export default useGetBattleDemoPvPSeasons
